import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import { formatDayLabel, dayNameFor } from "@produce/shared";

interface DayTabsProps {
  /** Festival dates in chronological order ("yyyy-mm-dd"). */
  dates: string[];
  selectedDate: string;
  onSelect: (date: string) => void;
  /** The briefing's `day_names` map, for custom per-day labels. */
  dayNames?: unknown;
  className?: string;
}

/**
 * Day-selector buttons (Day 1 / Day 2 / Day 3 …) for multi-day
 * productions. Renders nothing for single-day events, so callers can
 * drop it in unconditionally. Labels come from the shared formatDayLabel
 * helper so they read identically to the wizard and the crew app.
 */
export function DayTabs({ dates, selectedDate, onSelect, dayNames, className }: DayTabsProps) {
  if (dates.length <= 1) return null;
  return (
    <div className={cn("mb-4 flex flex-wrap gap-2", className)}>
      {dates.map((date, index) => (
        <Button
          key={date}
          type="button"
          size="sm"
          variant={date === selectedDate ? "default" : "outline"}
          onClick={() => onSelect(date)}
        >
          {formatDayLabel({ index, customName: dayNameFor(dayNames, date) })}
        </Button>
      ))}
    </div>
  );
}
